import { Component, Input, OnInit } from "@angular/core";
import { SharedService } from "../../../services";

@Component({
    selector: "app-announcements-frame",
    templateUrl: "./announcements-frame.component.html",
})
export class AnnouncementsFrameComponent implements OnInit
{

    @Input() announcement: string;
    newAnnouncement: string = "";

    constructor(
        private sharedService: SharedService,
    ) { }

    ngOnInit(): void
    {
        this.setAnnouncement();
    }

    setAnnouncement(): void
    {

        this.newAnnouncement = this.editAnnouncement(this.announcement);

        /* tslint:disable-next-line */  // string literal ignored...
        document.getElementById("frame").innerHTML = (this.newAnnouncement);

    }

    editAnnouncement(content: string): string
    {
        let newString = content;

        if (this.sharedService.isDark)
        {
            newString = newString.replace("body { ", "body { color: white !important; ");
            newString = newString.replace(/#333333|#000000/gi, "white");
        }

        newString = newString.replace(/verdana|arial|calibri/gi, "Roboto");

        return newString;
    }
}